import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges
} from "@angular/core";

@Directive({
  selector: "[iframeDocumentWrite]",
  standalone: false
})
export class IFRameDocumentWriteDirective implements OnChanges {
  @Input("iframeDocumentWrite") IFRameDocumentWriteDirective:
    | string
    | undefined;

  constructor(private elementRef: ElementRef<HTMLIFrameElement>) {}

  ngOnChanges(changes: SimpleChanges) {
    const iFRameDocumentWriteDirectiveChanges =
      changes["IFRameDocumentWriteDirective"];
    if (iFRameDocumentWriteDirectiveChanges) {
      this.writeHTMLToDocument(
        iFRameDocumentWriteDirectiveChanges.currentValue
      );
    }
  }

  writeHTMLToDocument(html: string): void {
    const document = this.elementRef.nativeElement.contentWindow?.document;

    document?.open();
    document?.write(html || "");
    document?.close();
  }
}
